import {
  OAUTH_APPLICATION_INIT,
  OAUTH_APPLICATION_SET_FORM_STATE,
  OAUTH_APPLICATION_SHOW_ID_SECRET_MODAL,
  OAUTH_APPLICATION_HIDE_ID_SECRET_MODAL,
  OAUTH_APPLICATION_SUBMIT_ACTION
} from './constants'

export function submitAction ({action}) {
  return {
    type: OAUTH_APPLICATION_SUBMIT_ACTION,
    payload: {action}
  }
}

export function init ({app, scopes, categories}) {
  return {
    type: OAUTH_APPLICATION_INIT,
    payload: {
      app,
      scopes,
      categories
    }
  }
}

export function setFormState ({state}) {
  return {
    type: OAUTH_APPLICATION_SET_FORM_STATE,
    payload: {
      state
    }
  }
}

export function showIDSecretModal () {
  return {
    type: OAUTH_APPLICATION_SHOW_ID_SECRET_MODAL
  }
}

export function hideIDSecretModal () {
  return {
    type: OAUTH_APPLICATION_HIDE_ID_SECRET_MODAL
  }
}



// WEBPACK FOOTER //
// app/javascript/components/actions/oauthApplication/oauthApplication.js